<template>
    <v-dialog v-model="isOpen" max-width="400">
        <div class="dialogClose">
            <div v-on:mousedown.prevent="isOpen = false" v-on:touchstart.prevent="isOpen = false"><img
                    src="/images/common/close.png" /></div>
        </div>
        <v-card class="dialogBase dialogMain">
            <v-card-text>
                <div class="text-center dialogHtpTitle windowTitle">QRをスキャンする</div>
                <v-row class="text-center">
                    <v-col cols="12" class="pa-0 pt-5 pb-10">
                        <v-col cols="12" class="pa-0">
                            <canvas ref="capCamera" width="240px" height="240px"></canvas>
                        </v-col>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<style scoped></style>
<script>

import '@/assets/style/window.css';

export default {
    data: () => ({
        isOpen: true,
        qrData: {}
    }),
    props: {
    },
    created: function () {
        this.viewQrReader();
        try {
            const frameA = this.$store.getters.dataFrameA;
            const frameB = this.$store.getters.dataFrameB;
            const frameC = this.$store.getters.dataFrameC;
            if (frameA) {
                for (let i in frameA.qrs) {
                    this.qrData[frameA.qrs[i]] = { "frame": "a", "num": i }
                }
            }
            if (frameB) {
                for (let i in frameB.qrs) {
                    this.qrData[frameB.qrs[i]] = { "frame": "b", "num": i }
                }
            }
            if (frameC) {
                for (let i in frameC.qrs) {
                    this.qrData[frameC.qrs[i]] = { "frame": "c", "num": i }
                }
            }

        } catch (error) {
            console.log(error);
        }

    },
    destroyed: function () {
        this.$stamp.stopCamera();
    },
    methods: {
        async viewQrReader(count) {
            if (!count) count = 1;
            if (this.$refs.capCamera) {
                try {
                    await this.$stamp.qrCamera(this.$refs.capCamera, (event) => {
                        // console.log("readQr", event.data, this.qrData[event.data], this.qrData);
                        // this.$stamp.stopCamera();

                        // 指定のQRを探す。見つからなければ無視してそのまま探し続ける。
                        if (this.qrData[event.data]) {
                            this.$stamp.stopCamera();
                            this.$emit('correct', this.qrData[event.data]);
                        }
                    })
                } catch (error) {
                    console.error(error);
                    this.$router.push({ name: 'error', params: { 'errormessage': "カメラが利用ができません。" } });
                }
            } else if (count < 5) {
                setTimeout(() => {
                    this.viewQrReader(count + 1)
                }, 300);
            }
        },
    },
    computed: {

    },
    watch: {
        isOpen(newVal) {
            if (!newVal) {
                this.$emit('close');
                this.$stamp.stopCamera();
            }
        }
    }
}
</script>